import Client from "./client";

const baseUrl = `/api/1/wallet/destination`;

function destinationWallets() {
  return {
    getAllMyDestinationWallets: data => {
      const url = !!data.params.queryParams
        ? baseUrl +
          `/self/${data.params.pageSize}/${data.params.pageNumber}?${data.params.queryParams}`
        : baseUrl + `/self/${data.params.pageSize}/${data.params.pageNumber}`;
      return Client.get(url);
    },
    getAllMyDestinationWalletsWithoutPagination: () => {
      return Client.get(baseUrl + `/self`);
    },
    getMyDestinationWalletById: id => {
      return Client.get(baseUrl + `/${id}`);
    },

    addNewDestinationWallets: dto => {
      return Client.post(baseUrl + `/`, dto);
    },
    deleteDestinationWallet: id => {
      return Client.delete(baseUrl + `/delete/${id}`);
    },
    deleteDestinationWallets: ids => {
      return Client.put(baseUrl + `/delete`, ids);
    },
    updateDestinationWallet: dto => {
      return Client.put(baseUrl + `/update`, dto);
    },
    validateWalletEmail: dto => {
      return Client.post(baseUrl + `/validate`, dto);
    },
    manyDestinationWallet: ids => {
      return Client.put(baseUrl + `/whitelist`, ids);
    },
    resendEmailForValidation: () => {
      return Client.put(baseUrl + `/resend`);
    }
  };
}

export default destinationWallets();
